import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';

class PlanningDashboardBalanceEditRoute extends Route {
  model() {
    return this.modelFor('planning.dashboard.balance');
  }
}

export default instrumentRoutePerformance(PlanningDashboardBalanceEditRoute);
